<span #render class="render" [class.inline]="inline" contenteditable="false" spellcheck="false"></span>

<span *ngIf="invalidCharacter" class="red">
  This equation contains an invalid character and needs to be remade, else it will not export properly.
</span>
